"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const head_1 = __importDefault(require("next/head"));
const dynamic_1 = __importDefault(require("next/dynamic"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const JourneyAppContext_1 = require("../../contexts/JourneyAppContext");
const usePageScrollRestore_1 = require("../../hooks/usePageScrollRestore");
const Alert_1 = require("./Alert");
const ErrorToolTip_1 = require("./ErrorToolTip");
const NoSSRStatusBarNotch = dynamic_1.default(() => Promise.resolve().then(() => __importStar(require('../Util/StatusBarNotch'))), { ssr: false });
let lastRouteChangeAt;
const JourneyApp = (props) => {
    const { children, authed } = props;
    usePageScrollRestore_1.usePageScrollRestore();
    const [error, setError] = react_1.useState();
    const [alertPayload, setAlertPayload] = react_1.useState();
    const appEleRef = react_1.useRef(null);
    const journeyAppContextValue = react_1.useMemo(() => ({
        error,
        setError,
        alert: alertPayload,
        setAlert: setAlertPayload,
        authed,
    }), [alertPayload, authed, error]);
    return (react_1.default.createElement(JourneyAppContext_1.JourneyAppContext.Provider, { value: journeyAppContextValue },
        react_1.default.createElement(head_1.default, null,
            react_1.default.createElement("meta", { name: "viewport", content: "width=device-width, initial-scale=1.0, viewport-fit=cover" })),
        react_1.default.createElement(NoSSRStatusBarNotch, null),
        react_1.default.createElement(Alert_1.Alert, null),
        react_1.default.createElement("div", { className: classnames_1.default('j-app'), ref: appEleRef }, children),
        react_1.default.createElement(ErrorToolTip_1.ErrorToolTip, null)));
};
exports.default = withJourney_1.default('', JourneyApp, { wrapsHref: false, collapseInModal: 'skipped' });
